export default import.meta.ROLLDOWN_FILE_URL_aTEEP2bmmlT0KAXNdGI82g